export default "__VITE_ASSET__DDExrIqI__"